import { Colors } from './Colors'

export const TextContents = {
    popup: {
        text: "Dans cette deuxième étape, placez les composantes du Fonds de Roulement et du Besoin en Fonds de Roulement.",
    },
    consigne : {
        text : "Placez les composantes du Fonds de Roulement et du Besoin en Fonds de Roulement.",
        config: { size: '22px', fontFamily: 'MassiliaMediumOblique', align: 'left', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    title : {
        text : "TRÉSORERIE NETTE, FONDS DE ROULEMENT ET BESOIN EN FONDS DE ROULEMENT",
        config: { size: '24px', fontFamily: 'MassiliaBold', align: 'left', color: Colors.Text.Red, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    subtitle : {
        text : "<class=\'regularOblique24\'>ÉTAPE 2 :</class> Fonds de Roulement et Besoin en Fonds de Roulement",
        config: { size: '24px', fontFamily: 'MassiliaRegular', align: 'left', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    popupFin : {
        text : "Bravo ! Vous avez placé toutes les composantes du Fonds de Roulement et du Besoin en Fonds de Roulement.",
        config: { size: '18px', fontFamily: 'MassiliaRegular', align: 'left', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    
}

export const CartesInfos = [
    {
        titre: "Bâtiment",
        index: 1,
        image: "batiment",
        zoneId: 2,
        correct: "Un bâtiment détenu par l'entreprise fait bien partie des investissements nécessaires à son activité (immobilisations) et intègre le calcul du Fonds de Roulement.",
        incorrect: {
            0: ["ATTENTION !", "Un bâtiment détenu par l'entreprise est effectivement une composante du Fonds de Roulement mais n'est pas une ressource à moyen et long terme. Il fait partie des investissements nécessaires à son activité (immobilisations). Retentez votre chance !"],
            1: ["MAUVAISE\nRÉPONSE","Un bâtiment détenu par l'entreprise fait partie des investissements nécessaires à son activité (immobilisations) et intègre le calcul du Fonds de Roulement. Retentez votre chance !"],
            3: ["MAUVAISE\nRÉPONSE","Un bâtiment détenu par l'entreprise fait partie des investissements nécessaires à son activité (immobilisations) et intègre le calcul du Fonds de Roulement. Retentez votre chance !"]
        }
    },
    {
        titre: "Créances clients",
        index: 2,
        image: "creance",
        zoneId: 1,
        correct: "La somme du montant des créances clients et des stocks moins les dettes fournisseurs constitue bien le Besoin en Fonds de Roulement.",
        incorrect: {
            0: ["MAUVAISE\nRÉPONSE","Les créances clients sont intégrées au calcul du Besoin en Fonds de Roulement. Retentez votre chance ! "],
            2: ["MAUVAISE\nRÉPONSE","Les créances clients sont intégrées au calcul du Besoin en Fonds de Roulement. Retentez votre chance ! "],
            3: ["ATTENTION !", "Les créances clients font effectivement partie du calcul du Besoin en Fonds de Roulement, mais ne viennent  pas en réduire le montant. Retentez votre chance !"]
        }
    },
    {
        titre: "Dettes fournisseurs",
        index: 3,
        image: "dettes",
        zoneId: 3,
        correct: "La somme du montant des stocks et des créances clients moins les dettes fournisseurs constitue bien le Besoin en Fonds de Roulement.",
        incorrect: {
            0: ["MAUVAISE\nRÉPONSE","Les dettes fournisseurs sont intégrées au calcul du Besoin en Fonds de Roulement. Retentez votre chance ! "],
            1: ["ATTENTION !","Les dettes fournisseurs font effectivement partie du calcul du Besoin en Fonds de Roulement, mais viennent en réduction du montant des stocks et des créances clients. Retentez votre chance ! "],
            2: ["MAUVAISE\nRÉPONSE","Les dettes fournisseurs sont intégrées au calcul du Besoin en Fonds de Roulement. Retentez votre chance ! "],
        }
    },
    {
        titre: "Emprunts bancaires",
        index: 4,
        image: "emprunt",
        zoneId: 0,
        correct: "Les emprunts bancaires font bien partie des ressources à moyen et long terme à disposition de l'entreprise et intègrent le calcul du Fonds de Roulement.",
        incorrect: {
            1: ["MAUVAISE\nRÉPONSE","Les emprunts bancaires sont des ressources à moyen et long terme intégrées au calcul du Fonds de Roulement. Retentez votre chance ! "],
            2: ["ATTENTION !", "Les emprunts bancaires sont effectivement une composante du Fonds de Roulement mais ne sont pas des immobilisations. Ils font partie des ressources à moyen et long terme à disposition de l'entreprise. Retentez votre chance !"],
            3: ["MAUVAISE\nRÉPONSE","Les emprunts bancaires sont des ressources à moyen et long terme intégrées au calcul du Fonds de Roulement. Retentez votre chance ! "]
        }
    },
    {
        titre: "Fonds de commerce",
        index: 5,
        image: "fonds",
        zoneId: 2,
        correct: "L'achat d'un fonds de commerce par l'entreprise fait bien partie des investissements nécessaires à son activité (immobilisations) et intègre le calcul du Fonds de Roulement.",
        incorrect: {
            0: ["ATTENTION !", "L'achat d'un fonds de commerce par l'entreprise est effectivement une composante du Fonds de Roulement mais n'est pas une ressource à moyen et long terme. Il fait partie des investissements nécessaires à son activité (immobilisations). Retentez votre chance !"],
            1: ["MAUVAISE\nRÉPONSE","Un fonds de commerce détenu par l'entreprise fait partie des investissements nécessaires à son activité (immobilisations) et intègre le calcul du Fonds de Roulement. Retentez votre chance !"],
            3: ["MAUVAISE\nRÉPONSE","Un fonds de commerce détenu par l'entreprise fait partie des investissements nécessaires à son activité (immobilisations) et intègre le calcul du Fonds de Roulement. Retentez votre chance !"]
        }
    },
    {
        titre: "Matériel",
        index: 6,
        image: "materiel",
        zoneId: 2,
        correct: "Le matériel acheté par l'entreprise fait bien partie des investissements nécessaires à son activité (immobilisations) et intègre le calcul du Fonds de Roulement.",
        incorrect: {
            0: ["ATTENTION !", "Le matériel acheté par l'entreprise est effectivement une composante du Fonds de Roulement mais n'est pas une ressource à moyen et long terme. Il fait partie des investissements nécessaires à son activité (immobilisations). Retentez votre chance !"],
            1: ["MAUVAISE\nRÉPONSE","Un matériel détenu par l'entreprise fait partie des investissements nécessaires à son activité (immobilisations) et intègre le calcul du Fonds de Roulement. Retentez votre chance !"],
            3: ["MAUVAISE\nRÉPONSE","Un matériel détenu par l'entreprise fait partie des investissements nécessaires à son activité (immobilisations) et intègre le calcul du Fonds de Roulement. Retentez votre chance !"]
        }
    },
    {
        titre: "Ressources stables",
        index: 7,
        image: "ressource",
        zoneId: 0,
        correct: "Le capital apporté par les actionnaires ou associés (ressources stables) fait bien partie des ressources à moyen et long terme à disposition de l'entreprise et intègre le calcul du Fonds de Roulement.",
        incorrect: {
            1: ["MAUVAISE\nRÉPONSE","Le capital apporté par les actionnaires ou associés (ressources stables) est une ressource à moyen et long terme intégrée au calcul du Fonds de Roulement. Retentez votre chance !"],
            2: ["ATTENTION !", "Le capital apporté par les actionnaires ou associés (ressources stables) est effectivement une composante du Fonds de Roulement mais n'est pas une « immobilisation ». Il fait partie des ressources à moyen et long terme à disposition de l'entreprise. Retentez votre chance !"],
            3: ["MAUVAISE\nRÉPONSE","Le capital apporté par les actionnaires ou associés (ressources stables) est une ressource à moyen et long terme intégrée au calcul du Fonds de Roulement. Retentez votre chance !"]
        }
    },
    {
        titre: "Résultats positifs non distribués",
        index: 8,
        image: "resultats",
        zoneId: 0,
        correct: "Les résultats positifs cumulés par l'entreprise et non distribués font bien partie des ressources à moyen et long terme à disposition de l'entreprise et intègrent le calcul du Fonds de Roulement.",
        incorrect: {
            1: ["MAUVAISE\nRÉPONSE","Les résultats positifs cumulés par l'entreprise et non distribués sont des ressources à moyen et long terme intégrées au calcul du Fonds de Roulement. Retentez votre chance ! "],
            2: ["ATTENTION !", "Les résultats positifs cumulés par l'entreprise et non distribués sont effectivement une composante du Fonds de Roulement mais ne sont pas des immobilisations. Ils font partie des ressources à moyen et long terme à disposition de l'entreprise. Retentez votre chance !"],
            3: ["MAUVAISE\nRÉPONSE","Les résultats positifs cumulés par l'entreprise et non distribués sont des ressources à moyen et long terme intégrées au calcul du Fonds de Roulement. Retentez votre chance ! "]
        }
    },
    {
        titre: "Stocks",
        index: 9,
        image: "stock",
        zoneId: 1,
        correct: "La somme du montant des stocks et des créances clients moins les dettes fournisseurs constitue bien le Besoin en Fonds de Roulement.",
        incorrect: {
            0: ["MAUVAISE\nRÉPONSE","Les stocks sont intégrés au calcul du Besoin en Fonds de Roulement. Retentez votre chance ! "],
            2: ["MAUVAISE\nRÉPONSE","Les stocks sont intégrés au calcul du Besoin en Fonds de Roulement. Retentez votre chance ! "],
            3: ["ATTENTION !", "Les stocks font bien partie du calcul du Besoin en Fonds de Roulement, mais ne viennent pas en réduire le montant. Retentez votre chance !"]
        }
    }
]

export const ZonesInfos = [
    {
        index: 7,
        zoneX: 265,
        zoneY: 460,
        zoneId: 0,
        image: "imgPlaceholderBig"
    },
    {
        index: 8,
        zoneX: 432,
        zoneY: 460,
        zoneId: 0,
        image: "imgPlaceholderBig"
    },
    {
        index: 4,
        zoneX: 600,
        zoneY: 460,
        zoneId: 0,
        image: "imgPlaceholderBig"
    },
    {
        index: 9,
        zoneX: 815,
        zoneY: 460,
        zoneId: 1,
        image: "imgPlaceholderBig"
    },
    {
        index: 2,
        zoneX: 962,
        zoneY: 460,
        zoneId: 1,
        image: "imgPlaceholderBig"
    },
    {
        index: 1,
        zoneX: 265,
        zoneY: 715,
        zoneId: 2,
        image: "imgPlaceholderBig"
    },
    {
        index: 6,
        zoneX: 432,
        zoneY: 715,
        zoneId: 2,
        image: "imgPlaceholderBig"
    },
    {
        index: 5,
        zoneX: 600,
        zoneY: 715,
        zoneId: 2,
        image: "imgPlaceholderBig"
    },
    {
        index: 3,
        zoneX: 890,
        zoneY: 715,
        zoneId: 3,
        image: "imgPlaceholderBig"
    },
]